import { BaseClientService, Result, Error } from "../BaseClientService";

export class LpAnnouncementService extends BaseClientService {
  url: string;

  constructor() {
    super();
    this.url = this.API_BASE_URL + "/api/front/lp_announcement";
  }

  async getLatestAnnouncements(code: string): Promise<Result<LpAnnouncementOutput, Error>> {
    return this.doSearch(`${this.url}/latest?code=${code}`);
  }
}

type LpAnnouncementOutput = {
  announcements: {
    id: number;
    announce_at: string;
    title: string;
    content: string;
    heading: string;
    prioritizes: boolean;
  }[];
};
